import {
  CLEAR_SETTINGS,
  ADD_SETTING,
  SETTING_ADDED,
  UPDATE_LAST_SETTING,
  REMOVE_LAST_SETTING,
  UPDATE_SETTINGS_IDS,
  UPDATE_CURRENT_SETTING_ID,
  APPLY_ADJUST,
  SET_IMAGE_STATUS,
  TOGGLE_SHOULD_CONFIRM_REVERT,
} from '../types/settings.types'

export const clearSettings = () => ({ type: CLEAR_SETTINGS })
export const addNewSetting = (setting) => ({ type: ADD_SETTING, payload: setting })
export const settingAdded = (setting) => ({ type: SETTING_ADDED, payload: setting })
export const updateLastSetting = (setting) => ({ type: UPDATE_LAST_SETTING, payload: setting })
export const removeLastSetting = () => ({ type: REMOVE_LAST_SETTING })
export const updateSettingsIds = (id) => ({ type: UPDATE_SETTINGS_IDS, payload: id })
export const updateCurrentSettingId = (id) => ({ type: UPDATE_CURRENT_SETTING_ID, payload: id })
export const applyAdjust = (name) => ({ type: APPLY_ADJUST, payload: name })
export const setImageStatus = () => ({ type: SET_IMAGE_STATUS })
export const toggleShouldConfirmRevert = () => ({ type: TOGGLE_SHOULD_CONFIRM_REVERT })
